import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
    ecAddressWrapper: {
        "& .ecAddressTitleWrapper": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "30px 0"
        },
        "& .ecAddressContentWrapper": { display: "flex", gap: "30px" },
        "& .ecBillingWrapper": {
            maxWidth: "100%",
            width: "100%",
            height: "65vh",
            overflow: "auto",
            position: "relative"
        },
    }
})